import { connect } from 'react-redux'
import OrdersEditView from './OrdersEditView.jsx'


class OrdersUnshipView extends OrdersEditView {
  constructor(props, context) {
    const localProps = {
      ...props,
      initialState: {
        status: 'approved'
      }
    }

    super(localProps, context)
  }
}

const mapStateToProps = (state) => {
  return {
    page: 'unship',
    order: state.orders.current.order,
    currentUser: state.currentUser.user,
    skus: state.skus.all || [],
    serverErrors: state.errors.orders.create || {}
  }
}

const connectedOrdersUnshipView = connect(mapStateToProps,)(OrdersUnshipView)
export default connectedOrdersUnshipView